import { createAsyncThunk } from '@reduxjs/toolkit'
import { SOMETHING_WHEN_WRONG } from 'constant/errorMessages'
import { callErrorMsg } from 'helpers/errorMsg'
import { getAllLocations } from 'features/Location/services/location'
import {
  createSOScheduleAPI,
  CreateSOScheduleRequestType,
  getSOScheduleByIdAPI,
  getSOScheduleDestinationsAPI,
  GetSOScheduleDestinationsRequestType,
  getSupplyOrderRemarksAPI,
  getWimsConstantsAPI,
  updateSOScheduleAPI,
  UpdateSOScheduleRequestType,
} from '../../services/soSchedules'

export const SLICE_NAME = 'SO_SCHEDULES_ADD_EDIT'

export const fetchGetAllLocations = createAsyncThunk(
  `${SLICE_NAME}/fetchGetAllLocations`,
  async (_, { rejectWithValue }) => {
    try {
      const response = await getAllLocations()

      return response.data
    } catch (err) {
      callErrorMsg(err)
      return rejectWithValue(SOMETHING_WHEN_WRONG)
    }
  },
)

export const fetchGetSupplyOrderRemarks = createAsyncThunk(
  `${SLICE_NAME}/fetchGetSupplyOrderRemarks`,
  async (_, { rejectWithValue }) => {
    try {
      const response = await getSupplyOrderRemarksAPI()

      return response.data
    } catch (err) {
      callErrorMsg(err)
      return rejectWithValue(SOMETHING_WHEN_WRONG)
    }
  },
)

export const fetchGetWimsConstants = createAsyncThunk(
  `${SLICE_NAME}/fetchGetWimsConstants`,
  async (_, { rejectWithValue }) => {
    try {
      const response = await getWimsConstantsAPI()

      return response.data
    } catch (err) {
      callErrorMsg(err)
      return rejectWithValue(SOMETHING_WHEN_WRONG)
    }
  },
)

export const fetchGetSOScheduleById = createAsyncThunk(
  `${SLICE_NAME}/fetchGetSOScheduleById`,
  async (id: number, { rejectWithValue }) => {
    try {
      const response = await getSOScheduleByIdAPI(id)

      return response.data
    } catch (err) {
      callErrorMsg(err)
      return rejectWithValue(SOMETHING_WHEN_WRONG)
    }
  },
)

export const fetchPostSOSchedule = createAsyncThunk(
  `${SLICE_NAME}/fetchPostSOSchedule`,
  async (
    { payload, onSuccess }: { payload: CreateSOScheduleRequestType; onSuccess?: () => void },
    { rejectWithValue },
  ) => {
    try {
      const response = await createSOScheduleAPI(payload)

      onSuccess?.()

      return response.data
    } catch (err) {
      callErrorMsg(err)
      return rejectWithValue(SOMETHING_WHEN_WRONG)
    }
  },
)

export const fetchPutSOScheduleById = createAsyncThunk(
  `${SLICE_NAME}/fetchPutSOScheduleById`,
  async (
    {
      id,
      payload,
      onSuccess,
    }: { id: number; payload: UpdateSOScheduleRequestType; onSuccess?: () => void },
    { rejectWithValue },
  ) => {
    try {
      const response = await updateSOScheduleAPI(id, payload)

      onSuccess?.()

      return response.data
    } catch (err) {
      callErrorMsg(err)
      return rejectWithValue(SOMETHING_WHEN_WRONG)
    }
  },
)

export const fetchGetSOScheduleDestinations = createAsyncThunk(
  `${SLICE_NAME}/fetchGetSOScheduleDestinations`,
  async (
    props: { id: number; params?: GetSOScheduleDestinationsRequestType },
    { rejectWithValue },
  ) => {
    try {
      const { id, params } = props

      const response = await getSOScheduleDestinationsAPI(id, params || {})
      return response.data
    } catch (err) {
      callErrorMsg(err)
      return rejectWithValue(SOMETHING_WHEN_WRONG)
    }
  },
)
